import * as React from "react";

// local-storage-alert-card imports
import * as s from "./LocalStorageAlertCard.styles";
import { IContainer, IProps, IState, ICardState } from "./LocalStorageAlertCard.d";

// components
import { asCard, CardButton } from "@components/card";
import { H2 } from "@components/ui";
import { CardTopLine } from "@components/card-top-line";

// state
import { isLocalStorageAvailable } from "@state/local-storage";

// util
import { ZonedMoment } from "@util/time-zone.util";
import { TrackingEvents, track } from "@util/analytics.util";

// material-ui
import { Check } from "@material-ui/icons";

class LocalStorageAlert extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      timeStamp: new ZonedMoment().format(),
    };
  }

  public componentDidMount() {
    track(TrackingEvents.SUGGESTIONS.LOCAL_STORAGE_ALERT_CARD_SHOWN);
  }

  public render() {
    return (
      <div style={s.container}>
        <div style={s.topLine}>
          <CardTopLine
            timeStamp={this.state.timeStamp}
            clear={this.props.removeCard}
            label="Warning"
          />
        </div>
        <div style={s.tipBanner} />
        <div style={s.tipBody}>
          <H2 style={{ ...s.tipHeader, color: s.headerColor }}>
            You must enable cookies for Clockwise to function properly
          </H2>
          <div style={s.tipSubHeading}>
            <div style={s.row}>
              <div style={s.number}>1</div>
              <div>
                Open cookie settings by going to this url: chrome://settings/content/cookies
              </div>
            </div>
            <div style={s.row}>
              <div style={s.number}>2</div>
              <div>At the bottom, in the "Allow" section, click "Add".</div>
            </div>
            <div style={s.row}>
              <div style={s.number}>3</div>
              <div>In the dialog that opens, copy and paste: [*.]getclockwise.com</div>
            </div>
            <div style={s.row}>
              <div style={s.number}>4</div>
              <div>Repeat step 2, this time in the dialog copy and paste: [*.]google.com</div>
            </div>
            <div style={s.explainer}>
              Without this setting, Clockwise will be logged out everytime you open Google Calendar
            </div>
          </div>
        </div>
        <div style={s.cardButtonContainer}>
          <CardButton
            flat
            label="Got it"
            icon={<Check />}
            onClick={() => this.props.removeCard()}
          />
        </div>
      </div>
    );
  }
}

// turn it into a card
const LocalStorageAlertCardCmpt = asCard<IProps>(LocalStorageAlert);

// wrap it to handle state decisions here
export class LocalStorageAlertCard extends React.Component<IContainer, ICardState> {
  constructor(props: IContainer) {
    super(props);
    const show = !isLocalStorageAvailable();
    this.state = {
      show,
    };

    if (this.props.updateCardCount) {
      this.props.updateCardCount(show ? 1 : 0); // count callback to know if we need to set empty state
    }
  }

  private onRemoveCard = () => {
    this.setState({ show: false });

    if (this.props.updateCardCount) {
      this.props.updateCardCount(0); // count callback to know if we need to set empty state
    }
  };

  public render() {
    if (this.state.show) {
      return <LocalStorageAlertCardCmpt removeCard={() => this.onRemoveCard()} />;
    } else {
      return null;
    }
  }
}
